module.exports = __webpack_public_path__ + "media/logos/press-logo-plaintiffs-9b25eca1.png";